import _ from "lodash";
import React, { useEffect, useState } from "react";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import { Box, Button, TextField, InputLabel, Checkbox, Divider, } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import IconNewRecord from "src/assets/images/icon_newrecord.svg";
import IconTruckGo from "src/assets/images/icon_truck_go.svg";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { toast } from "react-toastify";
import { commonFileUpload, getAllNofificationForDashboard } from "src/thunks/dashboard";
import { Loader } from "src/components/loader";
import toastMessages from "src/constant/toastMessages.json";
import { getDispatchOrderByIdAction, saveNewLaodInData } from "src/thunks/dispatchOrder";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { AddingZeroOnTime, GetError, isNumber, isDecimel, getFloatValue, convertIsoToLocalDateTime } from "src/constant";
import IconDownload from "src/assets/images/icon_download.svg";
import PrintPdfComponent from "./PrintPdf";
import { v4 as uuidv4 } from "uuid";
import { Search, Close } from "@mui/icons-material";
import { PDFDownloadLink } from "@react-pdf/renderer";


export const LoadOrderForm = ({ handleLoadOrderClose, getIndividualDispatchOrderDataMod }) => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  let { id } = useParams();
  const dispatch = useDispatch();
  const { goodsData, remarks, addNewVehicleLoadingState, ...rest } = useSelector((state) => state.dispatch);
  const lookupValues = useSelector((state) => state.lookup.data);

  /** hooks useState ----------------------------------------------------- **/
  const [ActiveIndex, setActiveIndex] = useState(0);
  const [availableData, setavailableData] = useState([]);
  // const [newAvalData, setNewAvaldata] = useState([]);
  const [dispatchDetailsData, _dispatchDetailsData] = useState({});
  const [allDispatchItem, _allDispatchItem] = useState([]);
  const [loader, setLoader] = useState(false);
  const [isFormDirty, setFormDirty] = useState(false);
  const [consoldatedDispatchData, setConsoldatedDispatchData] = useState(null);
  const [photoLoader, setPhotoLoader] = useState(false);
  const [documentLoader, setDocumentLoader] = useState(false);
  const [activeDataErrors, setActiveDataErrors] = useState({
    vrn: null,
    description: null,
    driverName: null,
    contact: null,
    externalSpaceReleased: null,
    internalSpaceReleased: null
  });
  const [highlightedRow, setHighlightedRow] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  /** variable declarations ----------------------------------------------------- **/
  let dispatchId = parseInt(id);
  let getIndividualDispatchOrderData = { ...rest.getIndividualDispatchOrderData };
  getIndividualDispatchOrderData.deliveryItems = getIndividualDispatchOrderData.deliveryItems.map((item) => {
    return {
      ...item,
      condition: lookupValues?.find((v) => v.id === item.conditionId)?.name,
    };
  });
  const VehicleObjectData = {
    tabName: "VEHICLE",
    vehicalName: uuidv4(),
    vehicleRegistration: getIndividualDispatchOrderDataMod?.vrn,
    vehicleModel: getIndividualDispatchOrderDataMod?.vehicleModel,
    driverName: getIndividualDispatchOrderDataMod?.driverName,
    driverContact: getIndividualDispatchOrderDataMod?.driverContact,
    departureDate: new Date(),
    departureTime1: moment().hour(),
    departureTime2: moment().minute(),
    internalSpaceReleased: 0,
    externalSpaceReleased: 0,
    key: uuidv4(),
    items: [],
    dispatchEvidences: [],
  };
  const [vehicalData, setVehicalData] = useState([{ ...VehicleObjectData }]);
  let ActiveData = vehicalData.length > 0 ? vehicalData[ActiveIndex] : [];

  let newVehical = [...vehicalData, { tabName: "ADD" }];
  // let newVehical = [...vehicalData];

  let ImagesFilter;
  let documentFilter;
  if (ActiveData?.dispatchEvidences) {
    ImagesFilter = [..._.filter(ActiveData.dispatchEvidences, (d) => d.key === ActiveData["key"] && d.typeId == 26 && !d.isToBeDeleted)];
    documentFilter = [..._.filter(ActiveData.dispatchEvidences, (d) => d.key === ActiveData["key"] && d.typeId == 25 && !d.isToBeDeleted)];
  }
  let damageCount = _.filter(dispatchDetailsData?.deliveryItems, (d) => d.condition === "Damaged")?.length || 0;
  let unitsCount = _.sumBy(dispatchDetailsData?.deliveryItems, (d) => d.quantity) || 0;
  let unitsCountForDispatch = _.sumBy(allDispatchItem, (d) => d.quantityDispatched);
  let userDetails = JSON.parse(localStorage.getItem("userDetails"))

  /** hooks useEffect----------------------------------------------------- **/
  useEffect(() => {
    let newData = { ...rest.getIndividualDispatchOrderData };
    newData.deliveryItems = newData.deliveryItems.map((item) => {
      return {
        ...item,
        condition: lookupValues?.find((v) => v.id === item.conditionId)?.name,
        storage: lookupValues?.find((v) => v.id === item.storageId)?.name,
      };
    });
    setAddedData(newData);
    _dispatchDetailsData(newData || {});
  }, [rest.getIndividualDispatchOrderData]);

  /** handler functions--------------------------------------------------- **/
  const getDispatchOrderInDataFunc = async () => {
    try {
      await dispatch(getDispatchOrderByIdAction({ id: id || "22" })).unwrap();
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");

    }
  };

  function validateNumber(input) {
    var re = /^[0-9 -]*$/;
    return re.test(input);
  }

  const onchangeHandler = (key, value) => {
    let cloneVehicalData = _.cloneDeep(vehicalData);
    cloneVehicalData[ActiveIndex][`${key}`] = value;
    if (isFormDirty) {
      if (key == "vehicleRegistration") {
        if (value != "") {
          setActiveDataErrors({ ...activeDataErrors, vrn: null });
        } else {
          setActiveDataErrors({ ...activeDataErrors, vrn: "VRN is Required" });
        }
      }
      if (key == "vehicleModel") {
        if (value != "") {
          setActiveDataErrors({ ...activeDataErrors, description: null });
        } else {
          setActiveDataErrors({
            ...activeDataErrors,
            description: "Description is Required",
          });
        }
      }
      if (key == "driverName") {
        if (value != "") {
          setActiveDataErrors({ ...activeDataErrors, driverName: null });
        } else {
          setActiveDataErrors({
            ...activeDataErrors,
            driverName: "Driver Name is Required",
          });
        }
      }
      if (key == "externalSpaceReleased") {
        if (value != "") {
          setActiveDataErrors({ ...activeDataErrors, externalSpaceReleased: null });
        } else {
          setActiveDataErrors({
            ...activeDataErrors,
            externalSpaceReleased: "External space is Required",
          });
        }
      }
      if (key == "internalSpaceReleased") {
        if (value != "") {
          setActiveDataErrors({ ...activeDataErrors, internalSpaceReleased: null });
        } else {
          setActiveDataErrors({
            ...activeDataErrors,
            internalSpaceReleased: "Internal Space is Required",
          });
        }
      }
      if (key == "driverContact") {
        if (value != "") {
          setActiveDataErrors({ ...activeDataErrors, contact: null });
        } else {
          setActiveDataErrors({
            ...activeDataErrors,
            contact: "Driver contact is Required",
          });
        }
        if (!validateNumber(value)) {
          setActiveDataErrors({
            ...activeDataErrors,
            contact: "Enter Valid Phone",
          });
        }
      }
    }
    setVehicalData([...cloneVehicalData]);
  };

  const handleSearchInputChange = (e) => {
    const searchText = e.target.value;
    setSearchValue(searchText);
  }

  const handleClearSearchText = () => {
    handleSearchInputChange({ target: { value: "" } });
  };

  const setAddedData = (Data) => {
    if (Data?.dispatches && Data?.dispatches.length > 0) {
      let dispatchItem = [];
      let evidence = [];
      let VehicalData = _.map(Data?.dispatches, (d, key) => {
        let uniqueKey = uuidv4();
        dispatchItem = [...dispatchItem, ...d.dispatchItems];
        let dispatchEvidences = _.map(d?.dispatchEvidences, (d) => {
          return {
            ...d,
            // key: `dispatch${key + 1}`
            key: uniqueKey
          };
        });
        evidence = [...evidence, ...dispatchEvidences];
        let loadingDateTime = convertIsoToLocalDateTime(
          `${d?.loadingDateTime}.00Z`,
          "DD-MMM-YYYY, HH:mm"
        );
        return {
          ...d,
          status: lookupValues?.find((v) => v.id === d.statusId)?.name,
          tabName: `VEHICLE`,
          vehicalName: uuidv4(),
          key: uniqueKey,
          deliveredDate: d.deliveredDate || "",
          departure: d.departureDate || "",
          vehicleRegistration: d?.vrn || "",
          internalSpaceReleased: d?.internalSpaceReleased || 0,
          externalSpaceReleased: d?.externalSpaceReleased || 0,
          vehicleModel: d?.vehicleModel || "",
          driverName: d?.driverName || "",
          transitTime: d.transitTime || "",
          receiverName: d.receiverName || "",
          receiverPosition: d.receiverPosition || "",
          receiverPhone: d.receiverPhone || "",
          driverContact: d?.driverContact || "",
          departureDate: d?.loadingDateTime
            ? new Date(loadingDateTime)
            : new Date(),
          departureTime1: moment(
            new Date(loadingDateTime) || new Date()
          ).hour(),
          departureTime2: moment(
            new Date(loadingDateTime) || new Date()
          ).minute(),
          // departureDate: new Date(d?.departureDate + "Z") || new Date(),
          // departureTime1:
          //   parseInt(d?.departureDate?.slice(11, 13)) || moment().hour(),
          // departureTime2:
          //   parseInt(d?.departureDate?.slice(14, 16)) || moment().minute(),
          // key: `dispatch${key + 1}`,
          // key:uuidv4(),
          items: [
            ...d.dispatchItems.map((item) => {
              return {
                ...item,
                condition: lookupValues?.find((v) => v.id === item.conditionId)?.name,
                storage: lookupValues?.find((v) => v.id === item.storageId)?.name,
              };
            }),
          ],
          dispatchEvidences: [...dispatchEvidences],
        };
      });

      _allDispatchItem([...dispatchItem]);
      setVehicalData([...VehicalData]);
      // setAvailable Data Logic start
      let tempdispatchItems = [];
      _.map(Data?.dispatches, (d) => {
        tempdispatchItems = [...tempdispatchItems, ...d.dispatchItems];
      });

      let newdispatchItems = [];
      _.map(tempdispatchItems, (d) => {
        const findIndex = _.findIndex(newdispatchItems, (newdispatchItem) => newdispatchItem.itemId === d.itemId);
        if (findIndex !== -1) {
          newdispatchItems[findIndex]["quantityDispatched"] = (newdispatchItems[findIndex].quantityDispatched || 0) + (d?.quantityDispatched || 0);
          newdispatchItems = [...newdispatchItems];
        } else {
          newdispatchItems = [...newdispatchItems, { ...d }];
        }
      });

      setConsoldatedDispatchData({ ...newdispatchItems });
      let newAvailable = [];
      _.map(Data?.deliveryItems || [], (d) => {
        let temp = { ...d };
        let finddispatchItems = _.find(newdispatchItems, (d1) => d1.itemId === temp.itemId);
        if (finddispatchItems) {
          temp.quantityDispatched = parseInt(temp?.quantity || 0) - parseInt(finddispatchItems?.quantityDispatched || 0);
        } else {
          temp.quantityDispatched = parseInt(temp?.quantity || 0);
        }
        newAvailable = [...newAvailable, { ...temp }] // new line added
        // if (temp.quantityDispatched !== 0) {
        //   newAvailable = [...newAvailable, { ...temp }];
        // }
      });
      setavailableData([...newAvailable]);
    } else {
      let deliveryItem = Data?.deliveryItems || []
      let addQuantityDispatch = deliveryItem?.map((d) => {
        let temp = { ...d }
        temp["quantityDispatched"] = temp.quantity
        return temp
      })
      setavailableData([...addQuantityDispatch]);
    }
  };

  const handleTabClick = (data, index) => {
    if (data.tabName === "ADD") {
      if (filterDataNewAvalData?.length == 0) {
        toast.error(toastMessages.cannotAddMoreVechicle);
        return;
      }
      let errors = { ...activeDataErrors };
      if (ActiveData.vehicleRegistration == "") {
        errors.vrn = "VRN is Required";
      } else {
        errors.vrn = null;
      }
      if (ActiveData.vehicleModel == "") {
        errors.description = "Description is Required";
      } else {
        errors.description = null;
      }
      if (ActiveData.driverName == "") {
        errors.driverName = "Driver Name is Required";
      } else {
        errors.driverName = null;
      }
      if (ActiveData.driverContact == "") {
        errors.contact = "Driver contact is Required";
      }
      else if (!validateNumber(ActiveData.driverContact)) {
        errors.contact = "Enter Valid Phone";
      }
      else {
        errors.contact = null;
      }
      setFormDirty(true);
      setActiveDataErrors(errors);
      if (Object.values(errors).every((i) => i == null)) {
        setVehicalData([
          ...vehicalData,
          {
            ...VehicleObjectData,
            tabName: `VEHICLE`,
            vehicalName: uuidv4(),
            // key: `dispatch${index + 1}`,
            key: uuidv4(),

          },
        ]);
      }
      else {
        // toast.error(toastMessages.vechicalValidation);
      }
    } else {
      setActiveIndex(index);
    }
  };

  const handleAddItemClick = (id, index) => {
    let ActiveData = _.cloneDeep(vehicalData.length > 0 ? vehicalData[ActiveIndex] : []);

    const cloneAvailableData = _.cloneDeep(availableData);
    let FindIncrementData = _.findIndex(cloneAvailableData, (d) => d.deliveryItemId === id);

    let loadingUnit = cloneAvailableData[FindIncrementData]["loadingUnit"];
    if (loadingUnit > 0) {
      setHighlightedRow(null)
      let loadingDatClone = _.cloneDeep(ActiveData?.items || []);
      let FindLoadingDatandex = _.findIndex(loadingDatClone, (d) => d.deliveryItemId === id);
      if (FindLoadingDatandex !== -1) {
        loadingDatClone[FindLoadingDatandex]["quantityDispatched"] = (loadingDatClone[FindLoadingDatandex]["quantityDispatched"] || 0) + (cloneAvailableData[FindIncrementData]["loadingUnit"] || 0);
        onchangeHandler("items", [...loadingDatClone]);
      } else {
        let newData = { ...cloneAvailableData[FindIncrementData], quantityDispatched: cloneAvailableData[FindIncrementData]?.loadingUnit || 0 };
        onchangeHandler("items", [...(ActiveData?.items || []), { ...newData }]);
        delete newData.loadingUnit;
        delete newData?.id
      }
      cloneAvailableData[FindIncrementData]["quantityDispatched"] = (cloneAvailableData[FindIncrementData]?.quantityDispatched || 0) - (cloneAvailableData[FindIncrementData]?.loadingUnit || 0);
      cloneAvailableData[FindIncrementData]["loadingUnit"] = 0;
      setavailableData([...cloneAvailableData]);
    } else {
      setHighlightedRow(index)
    }
  };

  const handleRemoveItemIconClickFromTable = (id, index) => {
    let ActiveData = _.cloneDeep(vehicalData.length > 0 ? vehicalData[index ? index : index === 0 ? index : ActiveIndex] : []);
    const cloneAvailableData = _.cloneDeep(availableData);
    let FindIncrementData = _.findIndex(cloneAvailableData, (d) => d.deliveryItemId === id);
    let loadingDatClone = _.cloneDeep(ActiveData?.items || []);
    let FindLoadingDatandex = _.findIndex(loadingDatClone, (d) => d.deliveryItemId === id);
    if (FindIncrementData !== -1) {
      setavailableData((prevsta) => {
        let newData = prevsta.map((d, index) => {
          let temp = { ...d }
          if (FindIncrementData === index) {
            temp["quantityDispatched"] = temp["quantityDispatched"] + (loadingDatClone[FindLoadingDatandex]["quantityDispatched"]);
          }
          return temp
        })
        return [...newData]
      });
    } else {
      let newdata = {
        ...loadingDatClone[FindLoadingDatandex],
        quantityDispatched: loadingDatClone[FindLoadingDatandex]?.quantityDispatched,
      }
      setavailableData((prevsta) => [...prevsta, newdata]);
    }
    let filterData = _.filter(ActiveData?.items || [], (d) => d.deliveryItemId !== id);
    onchangeHandler("items", [...filterData]);
    let vehicalDataActiveData = vehicalData[ActiveIndex]
    let interiorspaceData = _.filter(vehicalDataActiveData?.items, (d) => (d.storage === "interior" && d.deliveryItemId !== id))
    let exteriorspacedata = _.filter(vehicalDataActiveData?.items, (d) => (d.storage !== "interior" && d.deliveryItemId !== id))
    if (interiorspaceData.length === 0) {
      vehicalDataActiveData.internalSpaceReleased = 0
    }
    if (exteriorspacedata?.length === 0) {
      vehicalDataActiveData.externalSpaceReleased = 0
    }
    let items = _.filter(vehicalDataActiveData?.items, (d) => d.deliveryItemId !== id)
    vehicalData[ActiveIndex] = { ...vehicalDataActiveData, items: items }
    setVehicalData([...vehicalData])
  };

  const photoUpload = async (e) => {
    setPhotoLoader(true)
    const files = e.target.files;
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }
    try {
      let res = await dispatch(commonFileUpload(formData)).unwrap();
      setPhotoLoader(false);
      let PhotoType = lookupValues.find((v) => v.name === "Pictures").id;
      const processedData = res.map((result) => ({
        ...result,
        typeId: PhotoType,
        isDamaged: false,
        isToBeDeleted: false,
        dispatchId: ActiveData?.id || 0,
        key: ActiveData.key,
      }));
      let OldData = _.cloneDeep(vehicalData);
      let getIndex = _.findIndex(vehicalData, (d) => d.key === ActiveData.key);
      OldData[getIndex].dispatchEvidences = [
        ...OldData[getIndex].dispatchEvidences,
        ...processedData,
      ];
      setVehicalData([...OldData]);
    } catch (err) {
      setPhotoLoader(false);
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  const documentUpload = async (e) => {
    setDocumentLoader(true);
    const files = e.target.files;
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }
    try {
      let res = await dispatch(commonFileUpload(formData)).unwrap();
      setDocumentLoader(false);
      let DocumentType = lookupValues.find((v) => v.name === "Documents").id;
      const processedData = res.map((result) => ({
        ...result,
        typeId: DocumentType,
        isDamaged: false,
        isToBeDeleted: false,
        dispatchId: ActiveData?.id || 0,
        key: ActiveData.key,
      }));
      let OldData = _.cloneDeep(vehicalData);
      let getIndex = _.findIndex(vehicalData, (d) => d.key === ActiveData.key);
      OldData[getIndex].dispatchEvidences = [
        ...OldData[getIndex].dispatchEvidences,
        ...processedData,
      ];
      setVehicalData([...OldData]);
    } catch (err) {
      setDocumentLoader(false);
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  const IsDamageChangeHandler = (ichecked, id) => {
    let OldData = _.cloneDeep(ActiveData.dispatchEvidences);
    let getIndex = _.findIndex(OldData, (d) => d.uniqueFileId === id);
    OldData[getIndex].isDamaged = ichecked;
    OldData[getIndex].isToBeDeleted = false;

    const VehicalDataClone = _.cloneDeep(vehicalData);
    const getActiveDataIndex = _.findIndex(
      vehicalData,
      (vehicalDataItem) => vehicalDataItem.key === ActiveData.key
    );
    VehicalDataClone[getActiveDataIndex]["dispatchEvidences"] = [...OldData];
    setVehicalData([...VehicalDataClone]);
  };

  const handleRemoveImageClick = (id) => {
    let OldData = _.cloneDeep(ActiveData.dispatchEvidences);
    _.remove(OldData, (i) => i.uniqueFileId === id);
    const VehicalDataClone = _.cloneDeep(vehicalData);
    const getActiveDataIndex = _.findIndex(
      vehicalData,
      (vehicalDataItem) => vehicalDataItem.key === ActiveData.key
    );
    VehicalDataClone[getActiveDataIndex]["dispatchEvidences"] = [...OldData];
    setVehicalData([...VehicalDataClone]);

  };

  const dispatchButtonHandler = async (ActiveData) => {
    let errors = { ...activeDataErrors };
    if (ActiveData.vehicleRegistration == "") {
      errors.vrn = "VRN is Required";
    } else {
      errors.vrn = null;
    }
    if (ActiveData.vehicleModel == "") {
      errors.description = "Description is Required";
    } else {
      errors.description = null;
    }
    if (ActiveData.driverName == "") {
      errors.driverName = "Driver Name is Required";
    } else {
      errors.driverName = null;
    }
    if (ActiveData.driverContact == "") {
      errors.contact = "Driver contact is Required";
    }
    else if (!validateNumber(ActiveData.driverContact)) {
      errors.contact = "Enter Valid Phone";
    }
    else {
      errors.contact = null;
    }
    setFormDirty(true);
    setActiveDataErrors(errors);
    if (ActiveData?.items?.length <= 0) {
      toast.error("Please add load items here")
    }
    if (Object.values(errors).every((i) => i == null) && ActiveData?.items?.length > 0) {
      try {
        setLoader(true);
        const updateData = await saveButtonHandler(ActiveData.key);
      } catch (err) {
        setLoader(false);
        toast.error(GetError(err?.response?.data?.errors) || "something issue");
      }
    }
  };

  const saveButtonHandler = async (id) => {
    let errors = { ...activeDataErrors };
    if (ActiveData.vehicleRegistration == "") {
      errors.vrn = "VRN is Required";
    } else {
      errors.vrn = null;
    }
    if (ActiveData.vehicleModel == "") {
      errors.description = "Description is Required";
    } else {
      errors.description = null;
    }
    if (ActiveData.driverName == "") {
      errors.driverName = "Driver Name is Required";
    } else {
      errors.driverName = null;
    }
    if (ActiveData.driverContact == "") {
      errors.contact = "Driver contact is Required";
    }
    else if (!validateNumber(ActiveData.driverContact)) {
      errors.contact = "Enter Valid Phone";
    }
    else {
      errors.contact = null;
    }
    if (ActiveData?.items?.length <= 0) {
      toast.error("Please add load items here")
    }
    setFormDirty(true);
    setActiveDataErrors(errors);
    if (Object.values(errors).every((i) => i == null) && ActiveData?.items?.length > 0) {
      let isUpdate = false;
      try {
        let newVehical = _.map(vehicalData, (d) => {
          let temp = { ...d };
          delete temp?.key;
          isUpdate = d?.id ? true : null;

          if (d.status == "Delivered") {
            temp["status"] = "Delivered";
          } else if (d.status == "InTransit" || id == d.key) {
            const status = _.find(lookupValues, (d) => d.id === getIndividualDispatchOrderData?.typeId)?.name
            if (status === "ClientCollection") {
              temp["status"] = "Delivered";
            } else
              temp["status"] = "InTransit";
          } else {
            temp["status"] = "Pending";
          }
          if (d.key == id) {
            temp["departure"] = `${moment(moment.utc(moment())).format(
              "YYYY-MM-DD"
            )}T${moment(moment.utc(moment())).format("HH:mm:ss")}`;
          } else if (d.status === "InTransit") {
            temp["departure"] = d.departure;
          } else {
            temp["departure"] = `${moment(moment.utc(moment())).format(
              "YYYY-MM-DD"
            )}T${moment(moment.utc(moment())).format("HH:mm:ss")}`;
          }
          temp["dispatchId"] = d?.id || null;
          let time = temp?.departureDate ? moment.utc(new Date(moment(temp?.departureDate).format("YYYY-MM-DD") + ' ' + `${AddingZeroOnTime(temp?.departureTime1)}:${AddingZeroOnTime(temp?.departureTime2)}:00`)) : ""
          temp["loadingDateTime"] = `${moment(time).format("YYYY-MM-DD")}T${moment(time).format("HH:mm:ss")}`;
          delete temp?.departureDate;
          delete temp?.departureTime1;
          delete temp?.departureTime2;
          delete temp?.tabName;
          return temp;
        });
        let reqObject = {
          id: id,
          isUpdateFlag: isUpdate,
          orderNo: getIndividualDispatchOrderData?.orderNo,
          depotId: getIndividualDispatchOrderData?.depotId,
          ClientName: getIndividualDispatchOrderData?.clientName,
          projectId: getIndividualDispatchOrderData?.projectId,
          typeName: lookupValues.find((v) => v.id === getIndividualDispatchOrderData?.typeId).name,
          dispatchDueDate: ActiveData?.departureDate,
          deliveryOrderId: getIndividualDispatchOrderData?.id || "",
          dispatches: newVehical.map((v) => {
            return {
              deliveryOrderId: getIndividualDispatchOrderData?.id,
              id: v.dispatchId ?? 0,
              vrn: v.vehicleRegistration,
              vehicleModel: v.vehicleModel,
              internalSpaceReleased: v?.internalSpaceReleased || 0,
              externalSpaceReleased: v?.externalSpaceReleased || 0,
              driverName: v.driverName,
              driverContact: v.driverContact,
              description: v.vehicleModel,
              deliveredDate: v?.deliveredDate || null,
              statusId: lookupValues.find((l) => l.typeName == "DispatchStatus" && l.name == v.status).id,
              departureDate: v.departure,
              loadingDateTime: v.loadingDateTime,
              transitTime: v?.transitTime || null,
              onSiteTime: v?.onSiteTime || null,
              receiverName: v?.receiverName || null,
              receiverPosition: v?.receiverPosition || null,
              receiverPhone: v?.receiverPhone || null,
              dispatchItems: v.items.map((item) => {
                return {
                  id: item.id ?? 0,
                  dispatchId: item.dispatchId ? item.dispatchId : 0,
                  itemId: item.itemId,
                  deliveryItemId: item.deliveryItemId,
                  quantityDispatched: item.quantityDispatched,
                  description: item.description,
                  departure: v.departure,
                };
              }),
              dispatchEvidences: [...v.dispatchEvidences],
            };
          }),
        };
        let saveData = await dispatch(saveNewLaodInData(reqObject)).unwrap();
        if (saveData) {
          if (userDetails?.roles == "SuperAdmin") {
            setTimeout(() => {
              dispatch(getAllNofificationForDashboard(1, 20));
            }, 2000);
          }
          handleLoadOrderClose();
          getDispatchOrderInDataFunc();

          setTimeout(() => {
            if (id) {
              toast.success(toastMessages.dispatchItemDispatched);
            }
            else if (isUpdate) {
              toast.success(toastMessages.dispatchItemEdited);
            } else {
              toast.success(toastMessages.dispatchItemAdded);
            }
          }, 200);
        }
      }
      catch (err) {
        setLoader(false);
        toast.error(GetError(err?.response?.data?.errors) || "something issue");
      }
    }
  };

  const RemoveVehical = (data, index) => {
    setActiveDataErrors({ vrn: null, description: null, driverName: null, contact: null }) // new line added for when vehicle delete then errors for previous vehicle also gets deleted.
    setTimeout(() => {
      let removedData = _.find(vehicalData, (d) => d.key === data?.key)
      let FilterVehical = _.filter(vehicalData, (d) => d.key !== data?.key)
      removedData?.items?.map((itemdata) => {
        handleRemoveItemIconClickFromTable(itemdata?.deliveryItemId, index)
      })
      setActiveIndex(0)
      setVehicalData([...FilterVehical])
    }, 5);
  }


  let newAvalData = _.filter(availableData || [], (d) => d.quantityDispatched)



  if (newAvalData.length === 0) {
    newVehical = newVehical.filter((d) => d.tabName !== "ADD")
  }

  const filterDataNewAvalData = _.filter(availableData, (value) => {
    return value.itemNumber
      .toLowerCase()
      .includes(searchValue.toLowerCase()) && value.quantityDispatched
  });

  if (loader) {
    return <Loader />;
  }
  return (
    <>
      <div>
        <div className="depot-form-header-style">
          {/* <PrintPdfComponent
            getIndividualDispatchOrderDataMod={getIndividualDispatchOrderDataMod}
            activeData={vehicalData[ActiveIndex]}
            allDispatchItem={allDispatchItem}
            id="loadorderId"
          /> */}
          <span className="allocate-mgnr-header-color me-2">
            LOAD DELIVERY ORDER{" "}
          </span>
          <span className="allocate-mgnr-subheader-color">
            {getIndividualDispatchOrderData?.orderNo || ""}
          </span>
        </div>
        <div className="mt-3" style={{ paddingLeft: 100, paddingRight: 100 }}>
          <div className="d-flex justify-content-between">
            <div className="load-order-req-text-style">REQUIREMENTS</div>
            <div className="load-order-req-text-style">LOADED</div>
          </div>

          <div className="mt-3">
            <table className="table goodsin-table table-borderless p-0">
              <thead>
                <tr>
                  <th>
                    <span className="items-table-header-count">
                      {getIndividualDispatchOrderData.deliveryItems?.length ||
                        0}
                    </span>
                    <span className="items-table-text"> ITEMS</span>
                  </th>
                  <th>
                    <span className="items-table-header-count">
                      {damageCount}
                    </span>
                    <span className="items-table-text"> DAMAGED</span>
                  </th>
                  <th>DESCRIPTION</th>
                  <th>
                    <span className="items-table-header-count">
                      {unitsCount}
                    </span>
                    <span className="items-table-text"> UNITS</span>
                  </th>
                  <th>
                    <span className="items-table-header-count">
                      {unitsCountForDispatch}{" "}
                    </span>
                    <span className="items-table-text">LOADED UNITS</span>
                  </th>
                </tr>
              </thead>
              <tbody className="goods-table-body">
                {_.orderBy(dispatchDetailsData?.deliveryItems || [], ["itemNumber"], ["asc"]).map(
                  (item, index) => {
                    let findDispatchData = _.filter(
                      allDispatchItem || [],
                      (d) => d.id === item.deliveryItemId
                    );

                    let units = _.find(
                      consoldatedDispatchData,
                      (d) => d.deliveryItemId == item.deliveryItemId
                    )?.quantityDispatched;
                    return (
                      <tr key={index} className="goodsin-items-tr">
                        <td>{item.itemNumber}</td>
                        <td>{item.condition}</td>
                        <td>{item.description}</td>
                        <td>{item.quantity}</td>
                        <td>{units ? units : "-"}</td>
                      </tr>
                    );
                  }
                )}
              </tbody>
              <tfoot>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="d-flex flex-wrap main-class-for-tabs mb-4">
            {newVehical.map((d, index) => {
              return (
                <div
                  key={index}
                  className={`d-flex vehicle-tab-names-style pe-2 load-order-req-text-style ${ActiveIndex == 0 ? "remove-border-for-tab" : ""
                    } 
                    ${d.vehicalName === ActiveData?.vehicalName
                      ? "color-change-for-tab"
                      : ""
                    } 
                    `}
                  onClick={() => handleTabClick(d, index)}
                >
                  {((d.tabName !== "ADD" && !["InTransit", "Delivered"].includes(d?.statusValue)) && (newVehical.length !== (newAvalData?.length == 0 ? 1 : 2))) ?
                    <div>
                      <ClearOutlinedIcon onClick={() => RemoveVehical(d, index)} className="me-1" style={{ color: "red", fontSize: 20 }} />
                    </div>
                    : null}
                  {d.tabName === "VEHICLE" ? `VEHICLE ${index + 1}` : d.tabName}
                  {/* {d.tabName === "VEHICLE" ? `VEHICLE` : d.tabName} */}

                </div>
              );
            })}
          </div>

          <div className="row mb-3">
            <div className="col-md-3">
              <TextField
                inputProps={{
                  readOnly:
                    ActiveData?.status == "InTransit" ||
                      ActiveData?.status == "Delivered"
                      ? true
                      : false,
                }}
                disabled={
                  ActiveData?.status == "InTransit" ||
                    ActiveData?.status == "Delivered"
                    ? true
                    : false
                }
                className="depot-form-textfields-style textfield-color-class"
                value={ActiveData?.vehicleRegistration || ""}
                id="standard-basic"
                onChange={(e) =>
                  onchangeHandler("vehicleRegistration", e.target.value)
                }
                label="VRN"
                variant="standard"
              />
              {activeDataErrors.vrn && (
                <div className="error-field-class">{activeDataErrors.vrn}</div>
              )}
            </div>
            <div className="col-md-3">
              <TextField
                inputProps={{
                  readOnly:
                    ActiveData?.status == "InTransit" ||
                      ActiveData?.status == "Delivered"
                      ? true
                      : false,
                }}
                disabled={
                  ActiveData?.status == "InTransit" ||
                    ActiveData?.status == "Delivered"
                    ? true
                    : false
                }
                className="depot-form-textfields-style textfield-color-class"
                value={ActiveData?.vehicleModel || ""}
                id="standard-basic"
                onChange={(e) =>
                  onchangeHandler("vehicleModel", e.target.value)
                }
                label="VEHICLE TYPE"
                variant="standard"
              />
              {activeDataErrors.description && (
                <div className="error-field-class">
                  {activeDataErrors.description}
                </div>
              )}
            </div>
            <div className="col-md-3">
              <TextField
                inputProps={{
                  readOnly:
                    ActiveData?.status == "InTransit" ||
                      ActiveData?.status == "Delivered"
                      ? true
                      : false,
                }}
                disabled={
                  ActiveData?.status == "InTransit" ||
                    ActiveData?.status == "Delivered"
                    ? true
                    : false
                }
                className="depot-form-textfields-style textfield-color-class"
                value={ActiveData?.driverName || ""}
                id="standard-basic"
                label="DRIVER NAME"
                onChange={(e) => onchangeHandler("driverName", e.target.value)}
                variant="standard"
              />
              {activeDataErrors.driverName && (
                <div className="error-field-class">
                  {activeDataErrors.driverName}
                </div>
              )}
            </div>
            <div className="col-md-3">
              <TextField
                inputProps={{
                  readOnly:
                    ActiveData?.status == "InTransit" ||
                      ActiveData?.status == "Delivered"
                      ? true
                      : false,
                }}
                disabled={
                  ActiveData?.status == "InTransit" ||
                    ActiveData?.status == "Delivered"
                    ? true
                    : false
                }
                className="depot-form-textfields-style textfield-color-class"
                id="standard-basic"
                onChange={(e) =>
                  onchangeHandler("driverContact", e.target.value)
                }
                type="string"
                value={ActiveData?.driverContact || ""}
                label="CONTACT NUMBER"
                variant="standard"
              />
              {activeDataErrors.contact && (
                <div className="error-field-class">
                  {activeDataErrors.contact}
                </div>
              )}
            </div>
          </div>



          {ActiveData?.status !== "InTransit" &&
            ActiveData?.status !== "Delivered" &&
            filterDataNewAvalData.length > 0 && (
              <div className="row mt-4 loaded-div-style">
                <div className="col-md-6">AVAILABLE</div>
                <div className="col-md-6">UNITS</div>
              </div>
            )}

          <div className="row">
            <div
              className="col-md-6"
              style={{ position: "relative", marginTop: 18 }}
            >
              <input
                style={{ position: "relative", width: "100%" }}
                className="search-input-for-depot-personal-tab"
                type="text"
                placeholder="Search item by item number..."
                value={searchValue}
                onChange={handleSearchInputChange}
              />
              {searchValue !== "" ? (
                <Close
                  style={{ cursor: "pointer" }}
                  onClick={handleClearSearchText}
                  className="search-icon-depotpersonal-style"
                />
              ) : (
                <Search className="search-icon-depotpersonal-style" />
              )}
            </div>

            <div className="col-md-6">

            </div>

          </div>

          <div className="mt-2">
            {filterDataNewAvalData?.length > 0 &&
              ActiveData?.status !== "InTransit" &&
              ActiveData?.status !== "Delivered" ?
              // newAvalData?.map((item, index) => {
              _.orderBy(filterDataNewAvalData || [], ["itemNumber"], ["asc"]).map((item, index) => {
                return (
                  <div style={{ flex: 1 }}
                    key={index}
                    className="d-flex flex-row align-items-center individual-dispatch-table-item-style mt-2 pt-2 pb-2"
                  >
                    <div style={{ flex: 5 }} className="dashboarddepotName-value-style">{item.itemNumber}</div>
                    <div style={{ flex: 3 }}>{item.condition}</div>
                    <div style={{ flex: 3 }} className="dashboarddepotName-value-style">{item.description}</div>
                    <div
                      className="d-flex justify-content-center" // needed to add space between space and description
                      style={{ flex: 2 }}>
                      {item?.quantityDispatched - (item?.loadingUnit || 0)}{" "}
                    </div>
                    <div style={{ flex: 2 }}>
                      <input
                        className="search-input-for-depot-personal-tab unit-item-range-style"
                        onChange={({ target }) => {
                          if (isNumber(target.value)) {
                            setHighlightedRow(null)
                            const cloneAvailableData = _.cloneDeep(availableData);
                            let FindIncrementData = _.findIndex(cloneAvailableData, (d) => d.deliveryItemId === item?.deliveryItemId);
                            cloneAvailableData[FindIncrementData]["loadingUnit"] = parseInt(target.value);
                            let Value = parseInt(cloneAvailableData[FindIncrementData]?.quantityDispatched) - parseInt(cloneAvailableData[FindIncrementData]?.loadingUnit || 0);
                            if (Value >= 0) {
                              setavailableData([...cloneAvailableData]);
                            } else {
                              cloneAvailableData[FindIncrementData]["loadingUnit"] = parseInt(cloneAvailableData[FindIncrementData]?.quantityDispatched)
                              setavailableData([...cloneAvailableData]);
                            }
                          }
                        }}
                        type="number"
                        value={item?.loadingUnit || ""}
                        // maxLength="3"
                        style={{ width: 40, height: 25, border: highlightedRow == index ? "1px solid red" : "" }}
                      />
                    </div>
                    <div style={{ flex: 2 }}>
                      {item.storage == "interior" ? "Int" : "Ext"}
                    </div>



                    {ActiveData?.status == "InTransit" ||
                      ActiveData?.status == "Delivered" ? (
                      ""
                    ) : (
                      <div style={{ flex: 2 }} className="d-flex">
                        <button type="button"
                          style={{ cursor: "pointer" }}
                          className="add-item-button-style"
                          onClick={() => handleAddItemClick(item?.deliveryItemId, index)}
                        >
                          <img
                            src={IconNewRecord}
                            width={14}
                            height={14}
                            alt="new"
                          />
                          ADD
                        </button>
                      </div>
                    )}
                  </div>
                );
              }) :
              (
                <div>No records found</div>
              )
            }
          </div>

          <Divider
            variant="fullWidth"
            component="div"
            style={{
              backgroundColor: "blue",
              height: "2px",
              marginBottom: "1rem",
              marginTop: "1rem",
            }}
          />

          <div className="row mt-4 loaded-div-style">
            <div className="col-md-7">LOADED</div>

            <div className="col-md-3"></div>
          </div>

          <div className="mt-2">
            {ActiveData?.items && ActiveData?.items[0] ? (
              // ActiveData?.items.map((itemData, index) => {
              _.orderBy(ActiveData?.items || [], ["itemNumber"], ["asc"]).map((itemData, index) => {
                return (
                  <div style={{ flex: 1 }}
                    key={index}
                    className="d-flex flex-row individual-dispatch-table-item-style mt-2 pt-1 pb-1"
                  >
                    <div style={{ flex: 4 }}>{itemData.itemNumber}</div>
                    <div style={{ flex: 2 }} className="col-md-1">{itemData?.condition == "Good" ? "Good" : "Dmg"}</div>
                    <div style={{ flex: 4 }} className="col-md-2 dashboarddepotName-value-style-desc">{itemData.description}</div>
                    <div style={{ flex: 2 }} className="col-md-2">{itemData.quantityDispatched}</div>
                    <div style={{ flex: 1 }} className="col-md-2">{itemData.storage == "interior" ? "Int" : "Ext"}</div>


                    {ActiveData?.status == "InTransit" ||
                      ActiveData?.status == "Delivered" ? (
                      ""
                    ) : (
                      <div style={{ flex: 3 }}
                        className="d-flex justify-content-center align-items-center"
                        onClick={() => {
                          handleRemoveItemIconClickFromTable(itemData?.deliveryItemId)
                        }
                        }
                      >
                        <RemoveCircleOutlineOutlinedIcon
                          className="remove-item-icon-color"
                          style={{ cursor: "pointer", color: "red" }}
                          fontSize="20"
                        />
                        <span
                          className="ms-1 remove-item-label-color"
                          style={{
                            fontFamily: "Montserrat-Regular",
                            fontSize: 10,
                            cursor: "pointer",
                            color: "red"
                          }}
                        >
                          REMOVE
                        </span>
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div>No records found</div>
            )}
          </div>
          <div className="row mt-3">
            <div className="col-md-3" style={{ position: "relative" }}>
              <span> </span>
              <TextField
                inputProps={{
                  readOnly:
                    ActiveData?.status == "InTransit" ||
                      ActiveData?.status == "Delivered"
                      ? true
                      : _.filter(ActiveData?.items || [], (d) => d.storage == "interior").length > 0 ? false : true,
                }}
                disabled={
                  ActiveData?.status == "InTransit" ||
                    ActiveData?.status == "Delivered"
                    ? true
                    : _.filter(ActiveData?.items || [], (d) => d.storage == "interior").length > 0 ? false : true
                }
                className="depot-form-textfields-style textfield-color-class"
                id="standard-basic"
                onChange={(e) => {
                  let internalSpaceOccupiedData = _.sumBy(
                    _.filter(
                      vehicalData,
                      (d) => d.key !== vehicalData[ActiveIndex]?.key
                    ),
                    (d) => parseFloat(d.internalSpaceReleased)
                  );
                  let newInternalSpace =
                    parseFloat(internalSpaceOccupiedData) +
                    parseFloat(e.target.value);

                  if ((parseFloat(getIndividualDispatchOrderData?.internalSpaceOccupied) >= parseFloat(newInternalSpace) || !parseFloat(e.target.value))) {
                    onchangeHandler("internalSpaceReleased", e.target.value)
                  }
                }
                }
                type="number"
                value={ActiveData?.internalSpaceReleased || ""}
                label="INTERNAL "
                variant="standard"
              />
              <div style={{ position: "absolute", right: 10, top: 15, }}>M<sup>2</sup></div>
              {activeDataErrors.internalSpaceReleased && (
                <div className="error-field-class">
                  {activeDataErrors?.internalSpaceReleased || ""}
                </div>
              )}
            </div>

            <div className="col-md-3" style={{ position: "relative" }}>
              <span> </span>
              <TextField
                inputProps={{
                  readOnly:
                    ActiveData?.status == "InTransit" ||
                      ActiveData?.status == "Delivered"
                      ? true
                      : _.filter(ActiveData?.items || [], (d) => d.storage !== "interior")?.length > 0 ? false : true,
                }}
                disabled={
                  ActiveData?.status == "InTransit" ||
                    ActiveData?.status == "Delivered"
                    ? true
                    : _.filter(ActiveData?.items || [], (d) => d.storage !== "interior")?.length > 0 ? false : true
                }
                className="depot-form-textfields-style textfield-color-class"
                id="standard-basic"
                onChange={(e) => {

                  let externalSpaceOccupiedData = _.sumBy(
                    _.filter(
                      vehicalData,
                      (d) => d.key !== vehicalData[ActiveIndex]?.key
                    ),
                    (d) => parseFloat(d.externalSpaceReleased)
                  );
                  let newExternalSpace =
                    parseFloat(externalSpaceOccupiedData) +
                    parseFloat(e.target.value);

                  if ((parseFloat(getIndividualDispatchOrderData?.externalSpaceOccupied) >= parseFloat(newExternalSpace) || !parseFloat(e.target.value))) {
                    onchangeHandler("externalSpaceReleased", e.target.value)
                  }
                }}
                type="number"
                value={ActiveData?.externalSpaceReleased || ""}
                label="EXTERNAL"
                variant="standard"
              />
              <div style={{ position: "absolute", right: 10, top: 15, }}>M<sup>2</sup></div>
              {activeDataErrors?.externalSpaceReleased && (
                <div className="error-field-class">
                  {activeDataErrors?.externalSpaceReleased || ""}
                </div>
              )}
            </div>
            <div className="col-md-3 " style={{ position: "relative", paddingLeft: 20, display: "flex", justifyContent: "flex-end" }}>
              <div>
                <InputLabel className="goodsin-form-section-header-name">
                  INTERNAL OCCUPIED
                </InputLabel>
                <div className="mt-1" style={{ display: "flex", justifyContent: "flex-end" }}>
                  <span className="load-order-req-text-style" style={{ color: "black", fontWeight: "bold" }}>{getIndividualDispatchOrderData?.internalSpaceOccupied || 0}</span>
                  <span style={{ color: "black", marginLeft: 5, fontWeight: "bold", fontSize: 14 }}>M<sup>2</sup></span>
                </div>
              </div>
            </div>
            <div className="col-md-3" style={{ position: "relative", justifyContent: "flex-end", display: "flex" }}>
              <div>
                <InputLabel className="goodsin-form-section-header-name">
                  EXTERNAL OCCUPIED
                </InputLabel>
                <div className="mt-1" style={{ display: "flex", justifyContent: "flex-end" }}>
                  <span className="load-order-req-text-style" style={{ color: "black", fontWeight: "bold" }}>{getIndividualDispatchOrderData?.externalSpaceOccupied || 0}</span>
                  <span style={{ color: "black", alignItems: "flex-end", marginLeft: 5, fontWeight: "bold", fontSize: 14 }}>M<sup>2</sup></span>
                </div>
              </div>
            </div>
          </div>

          <div className="row pt-3 pb-0 mb-2 mt-2 ps-1">
            <div className="col-md-2">
              <InputLabel className="goodsin-form-section-header-name">
                {" "}
                {ImagesFilter?.length > 0 ? ImagesFilter?.length : ""} PHOTOS
              </InputLabel>
            </div>
            <div className="col-md-10">
              {photoLoader &&
                <div className="spinner-border spinner-border-sm text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>}
            </div>
          </div>
          {ImagesFilter?.length > 0 ?
            <>
              <div className="row">
                {ImagesFilter &&
                  ImagesFilter[0] &&
                  ImagesFilter.map((d, index) => {
                    return (
                      <div
                        key={index}
                        style={{ marginBottom: 2, width: 130, paddingTop: 10 }}
                      >
                        <Box
                          component="img"
                          style={{ height: 88, width: "100%" }}
                          alt="The house from the offer."
                          src={d.url}
                        />
                        {ActiveData?.status == "InTransit" ||
                          ActiveData?.status == "Delivered" ? (
                          ""
                        ) : (
                          <>
                            <div
                              style={{
                                display: "flex",
                                justifyItems: "center",
                                height: 20,
                                marginTop: 6,
                              }}
                              className="checkbox-style-class"
                            >
                              <Checkbox
                                style={{ color: "#E94F37" }}
                                checked={d.isDamaged ? true : false}
                                onChange={({ target }) =>
                                  IsDamageChangeHandler(
                                    target.checked,
                                    d.uniqueFileId
                                  )
                                }
                              />
                              <InputLabel
                                className="checkbox-label"
                                style={{
                                  fontSize: 10,
                                  fontFamily: "Montserrat-Regular",
                                }}
                              >
                                {" "}
                                DAMAGES
                              </InputLabel>
                            </div>
                            <div
                              onClick={() => handleRemoveImageClick(d.uniqueFileId)}
                              style={{
                                display: "flex",
                                justifyItems: "center",
                                alignItems: "center",
                                paddingLeft: 4,
                                height: 20,
                                cursor: "pointer",
                              }}
                            >
                              <RemoveCircleOutlineOutlinedIcon
                                fontSize="20"
                                color="red"
                              />
                              <InputLabel
                                style={{
                                  fontSize: 10,
                                  marginBottom: 10,
                                  color: "red",
                                  fontFamily: "Montserrat-Regular",
                                }}
                              >
                                {" "}
                                REMOVE
                              </InputLabel>
                            </div>
                          </>
                        )}
                      </div>
                    );
                  })}
              </div>
            </>
            : ""}

          <div style={{ marginBottom: 2, width: 130, paddingTop: 10 }}>
            {ActiveData?.statusValue == "InTransit" ||
              ActiveData?.statusValue == "Delivered" ? (
              ""
            ) : (
              <div className="row mt-2">
                <div className="fileUpload">
                  <input
                    type="file"
                    className="upload"
                    accept="image/png, image/jpeg, image/jpg"
                    multiple
                    onChange={(e) => photoUpload(e)}
                  />
                  <div
                    style={{
                      border: "1px solid #4879e2",
                      height: "100%",
                      textAlign: "center",
                    }}
                  >
                    <i
                      className="bi bi-plus-circle-fill"
                      style={{ color: "#4879e2" }}
                    ></i>
                    <div
                      style={{
                        fontSize: 10,
                        color: "#0045d9",
                        fontFamily: "Montserrat-Regular",
                      }}
                    >
                      {" "}
                      ADD PHOTO
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>


          <div className="row pt-3 pb-0 mb-2 mt-2 ps-1">
            <div className="col-md-2">
              <InputLabel className="goodsin-form-section-header-name">
                {" "}
                {documentFilter?.length > 0 ? documentFilter?.length : ""} DOUCMENTS
              </InputLabel>
            </div>
            <div className="col-md-10">
              {documentLoader &&
                <div className="spinner-border spinner-border-sm text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>}
            </div>
          </div>

          {documentFilter?.length > 0 ?
            <>
              {documentFilter &&
                documentFilter[0] &&
                documentFilter.map((d, index) => {
                  return (
                    <div key={index} className="row mt-2">
                      <div className="col-md-4">{d?.fileName || ""}</div>
                      <div className="col-md-4">
                        {/* <div style={{ width: "60%" }}>
                                <div className="progress">
                                    <div className="progress-bar" role="progressbar" style={{ width: "25%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div>
                                </div>
                            </div> */}
                      </div>
                      {ActiveData?.status == "InTransit" ||
                        ActiveData?.status == "Delivered" ? (
                        ""
                      ) : (
                        <div
                          className="col-md-4"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleRemoveImageClick(d.uniqueFileId)}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyItems: "center",
                              color: "red",
                            }}
                          >
                            <RemoveCircleOutlineOutlinedIcon fontSize="20" />
                            <InputLabel
                              style={{ fontSize: 10, marginTop: -3, color: "red" }}
                            >
                              {" "}
                              Remove
                            </InputLabel>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
            </>
            : ""}

          <div className="mt-3">
            {ActiveData?.statusValue == "InTransit" ||
              ActiveData?.statusValue == "Delivered" ? (
              ""
            ) : (
              <div className="fileUpload-doc">
                <input
                  type="file"
                  className="upload"
                  multiple
                  accept=".doc, .txt , .pdf"
                  onChange={(e) => documentUpload(e)}
                />
                <div>
                  <AddCircleOutlinedIcon style={{ fontSize: 16 }} />
                  <span className="add-doc-button-style">ADD DOCUMENT</span>
                </div>
              </div>
            )}
          </div>

          <div className="row pt-3 pb-0 mb-2 mt-2 ps-1">
            <InputLabel className="goodsin-form-section-header-name">
              {" "}
              LOADING TIME
            </InputLabel>
          </div>

          <div
            className="row d-flex justify-content-center align-items-center"
            style={{ height: 70 }}
          >
            <div className="col-md-6">
              <div className="row d-flex">
                <div className="col-md-6">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      disabled={
                        ActiveData?.status == "InTransit" ? true : false
                      }
                      label="Date"
                      value={
                        ActiveData?.departureDate
                          ? ActiveData?.departureDate
                          : new Date()
                      }
                      onChange={(newValue) =>
                        onchangeHandler("departureDate", newValue)
                      }
                      className="DatePickerOutline"
                      variant="standard"
                      id="standard-basic"
                      format="dd.MM.yyyy"
                      inputFormat="dd-MM-yyyy"
                    />
                  </LocalizationProvider>
                </div>
                <div className="col-md-6">
                  <select
                    disabled={ActiveData?.status == "InTransit" ? true : false}
                    value={ActiveData?.departureTime1 || 0}
                    onChange={({ target }) =>
                      onchangeHandler("departureTime1", target.value)
                    }
                    style={{
                      textAlign: "center",
                      borderTop: 0,
                      borderLeft: 0,
                      borderRight: 0,
                      borderBottom: "1px solid #5e89e7",
                      height: 42,
                    }}
                  >
                    {[...Array(24)].map((d, index) => {
                      const formattedValue = index.toString().padStart(2, '0');
                      return (
                        <option key={index} value={index}>
                          {/* {index} */}
                          {formattedValue}
                        </option>
                      );
                    })}
                  </select>
                  :
                  <select
                    disabled={ActiveData?.status == "InTransit" ? true : false}
                    value={ActiveData?.departureTime2 || 0}
                    onChange={({ target }) =>
                      onchangeHandler("departureTime2", target.value)
                    }
                    style={{
                      textAlign: "center",
                      marginLeft: 3,
                      borderTop: 0,
                      borderLeft: 0,
                      borderRight: 0,
                      borderBottom: "1px solid #5e89e7",
                      height: 42,
                    }}
                  >
                    {[...Array(60)].map((d, index) => {
                      const formattedValue = index.toString().padStart(2, '0');
                      if (index === 0) {
                        return <option key={index}>{"00"}</option>;
                      }
                      // return <option key={index}>{index}</option>;
                      return <option key={index} value={index}>{formattedValue}</option>;

                    })}
                  </select>
                </div>
              </div>
            </div>

            <div className="col-md-6 text-end">
              <Button onClick={() => !["InTransit", "Delivered"].includes(ActiveData?.status) && dispatchButtonHandler(ActiveData)}
                variant="outlined"
                disabled={addNewVehicleLoadingState ? true : false}
                className={`btn-bootstrap-submit-style dispatch-button-style ${!["InTransit", "Delivered"].includes(ActiveData?.status) ? "" : "changed-intransit-button-border"} ${addNewVehicleLoadingState ? "fade-out" : ""}`}
                startIcon={<img className="ms-2" src={IconTruckGo} alt="truck" />}
                type="submit"
              >
                {!["InTransit", "Delivered"].includes(ActiveData?.status)
                  ? "DISPATCH"
                  : "InTransit"}
              </Button>
            </div>
          </div>

          <div className="d-flex justify-content-end">
            {(getIndividualDispatchOrderDataMod?.typeValue == "Delivery" ||
              getIndividualDispatchOrderDataMod?.typeValue == "ClientCollection")
              && ActiveData?.items?.length > 0 &&
              ActiveData?.vehicleRegistration && ActiveData?.vehicleModel &&
              ActiveData?.driverName && ActiveData?.driverContact &&
              <PDFDownloadLink
                document={
                  <PrintPdfComponent
                    getIndividualDispatchOrderDataMod={
                      getIndividualDispatchOrderDataMod
                    }
                    activeData={ActiveData}
                    id="detailsId"
                  />
                }
                fileName={getIndividualDispatchOrderDataMod?.typeValue == "Delivery" ? "Dispatch-details.pdf" : "Collection-details.pdf"}
              >
                {({ blob, url, loading, error }) =>

                  <Button
                    style={{ display: loading ? "none" : "block" }}
                    className="download-doc-btn-style"
                    onClick={() => { }}
                  >
                    <img
                      className="me-2"
                      src={IconDownload}
                      width={15}
                      height={15}
                      alt="alt"
                    />
                    DOWNLOAD DOCUMENTS
                  </Button>

                }
              </PDFDownloadLink>
            }
          </div>

          <div
            className="row mt-5 mb-4"
            style={{ borderBottom: "1px solid #0045d9" }}
          ></div>
          <div
            className="d-flex flex-row justify-content-between"
            style={{ marginTop: 10, marginBottom: 20 }}
          >
            <Button
              variant="outlined"
              className="btn-bootstrap-submit-style"
              style={{ color: "red", borderColor: "red" }}
              startIcon={<CancelIcon />}
              onClick={() => handleLoadOrderClose()}
            >
              Cancel
            </Button>
            <Button onClick={() => saveButtonHandler()}
              variant="outlined"
              disabled={addNewVehicleLoadingState ? true : false}
              startIcon={<CheckCircleIcon />}
              className={`btn-bootstrap-submit-style ${addNewVehicleLoadingState ? "fade-out" : ""}`}
              type="submit"
            >
              Save
            </Button>
          </div>
        </div>
      </div >
    </>
  );
};